import { createAction } from 'redux-starter-kit';

/**
 * An action creator that puts a user in the store.
 * @param {object} user The user.
 * @example dispatch(putUser(user));
 */
export const putUser = createAction('PUT_USER');
export const putUsers = createAction('PUT_USERS');

/**
 * A action creator that removes a user from the store
 * @param userId The id of the user to remove.
 * @example dispatch(removeUser(userId));
 */
export const removeUser = createAction('REMOVE_USER');

/**
 * An action creator that adds users into the store.
 * This will replace any existing users with the same id.
 * @param {object[]} users Multiple users.
 * @example dispatch(addUsers(users));
 */
export const addUsers = createAction('ADD_USERS');

/**
 * An action creator that removes all users from the store.
 * @example dispatch(invalidateUsers());
 */
export const invalidateUsers = createAction('INVALIDATE_USERS');
